import React, { useState, createContext } from 'react'

export const GlobalUserContext = createContext();

const GlobalUserContextProvider = (props) => {
  const [getGlobalUser, setGlobalUser] = useState({'isLoggedIn': false})

  return (
    <GlobalUserContext.Provider value={{getGlobalUser, setGlobalUser}}>
      {props.children}
    </GlobalUserContext.Provider>
  )
}

export default GlobalUserContextProvider;
